import { InvoicePreview } from "@jugl-web/domain-resources/invoices/components/InvoicePreview";
import { InvoiceModel } from "@jugl-web/rest-api";
import { cx } from "@jugl-web/utils";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useInvoicesSettingsPageContext } from "@web-src/modules/invoices/pages/InvoicesSettingsPage/context/useInvoicesSettingsPageContext";

export const InvoiceSettingsPreview: React.FC = () => {
  const { formValues, customFields, logo, configId } =
    useInvoicesSettingsPageContext();
  const { entity } = useEntitySelectedProvider();

  const invoice: Partial<InvoiceModel> = {
    type: "invoice",
    no: formValues.prefix,
    currency: entity.currency,
    date: new Date().toISOString(),
    due_on: new Date().toISOString(),
    notes: formValues.note,
    bill_from: {
      line1: formValues.name || "",
      line2: formValues.street || "",
      line3: [
        formValues.city || "",
        formValues.state || "",
        formValues.zipCode || "",
      ]
        .filter(Boolean)
        .join(" "),
      line4: formValues.country || "",
      ...customFields.reduce((acc, field, idx) => {
        acc[`line${idx + 5}`] = field.value;
        return acc;
      }, {} as Record<string, string>),
    },
    bill_to: {
      name: "Kianna Bergson",
      street: "1234 Elm Street",
      city_state_zip: "Springfield, IL 62701",
      country: "United States",
    },
    items: [
      {
        inventory_id: null,
        name: "Full cleaning",
        desc: "",
        price: 2.5,
        qty: 1,
        total: 2.5,
        currency: null,
        price_type: null,
        category: null,
        unit: null,
        discount: { discount: 0, name: "", percentage: 0 },
        tax: [],
      },
      {
        inventory_id: null,
        name: "Deep cleaning",
        desc: "",
        price: 2.5,
        qty: 2,
        total: 5,
        currency: null,
        price_type: null,
        category: null,
        unit: null,
        discount: { discount: 0, name: "", percentage: 0 },
        tax: [],
      },
    ],
    total: 7.5,
    grand_total: 7.5,
    discount: [],
    tax: [],
  };

  return (
    <div
      className={cx(
        "jugl__custom-scrollbar overflow-y-auto overflow-x-visible py-8",
        {
          "max-h-[calc(100vh-16.2rem)]": !configId,
          "max-h-[calc(100vh-11.3rem)]": configId,
        }
      )}
    >
      <div className="rounded-2xl bg-white p-8">
        <InvoicePreview
          entityName={entity.name}
          invoice={invoice}
          logo={logo ? URL.createObjectURL(logo) : ""}
        />
      </div>
    </div>
  );
};
